"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var superagent_1 = __importDefault(require("superagent"));
var appConfig_1 = __importDefault(require("../config/appConfig"));
var API_BASE_URL = appConfig_1.default.getApiBaseUrl();
var buildApiUrl = function (endpoint) {
    var baseUrl = (API_BASE_URL === null || API_BASE_URL === void 0 ? void 0 : API_BASE_URL.trim()) || "";
    if (!baseUrl) {
        return endpoint;
    }
    var normalizedBase = baseUrl.replace(/\/+$/, "");
    return "".concat(normalizedBase).concat(endpoint);
};
var startSocialLogin = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, superagent_1.default
                    .post(buildApiUrl("/social-auth/social/login"))
                    .send(payload)
                    .timeout({ response: 4000, deadline: 8000 })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, (_a = response.body) === null || _a === void 0 ? void 0 : _a.data];
        }
    });
}); };
var startGoogleOAuthLogin = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, superagent_1.default
                    .post(buildApiUrl("/api/auth/google/verify"))
                    .send(payload)
                    .timeout({ response: 4000, deadline: 8000 })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, (_a = response.body) === null || _a === void 0 ? void 0 : _a.data];
        }
    });
}); };
var startFacebookOAuthLogin = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, superagent_1.default
                    .post(buildApiUrl("/api/auth/facebook/verify"))
                    .send(payload)
                    .timeout({ response: 4000, deadline: 8000 })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, (_a = response.body) === null || _a === void 0 ? void 0 : _a.data];
        }
    });
}); };
var startLineOAuthLogin = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, superagent_1.default
                    .post(buildApiUrl("/api/auth/line/verify"))
                    .send(payload)
                    .timeout({ response: 8000, deadline: 12000 })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, (_a = response.body) === null || _a === void 0 ? void 0 : _a.data];
        }
    });
}); };
var getTaskStatus = function (requestId) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, superagent_1.default
                    .get(buildApiUrl("/social-auth/task/".concat(encodeURIComponent(requestId))))
                    .timeout({ response: 4000, deadline: 8000 })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, (_a = response.body) === null || _a === void 0 ? void 0 : _a.data];
        }
    });
}); };
var getUserProfile = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, superagent_1.default
                    .get(buildApiUrl("/api/user/profile"))
                    .query({
                    user_id: payload.userId,
                    email: payload.email,
                    name: payload.name || "",
                    avatar_url: payload.avatarUrl || ""
                })
                    .timeout({ response: 4000, deadline: 8000 })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, (_a = response.body) === null || _a === void 0 ? void 0 : _a.data];
        }
    });
}); };
var socialAuthApi = {
    startSocialLogin: startSocialLogin,
    startGoogleOAuthLogin: startGoogleOAuthLogin,
    startFacebookOAuthLogin: startFacebookOAuthLogin,
    startLineOAuthLogin: startLineOAuthLogin,
    getTaskStatus: getTaskStatus,
    getUserProfile: getUserProfile
};
exports.default = socialAuthApi;
